const $ = window.jQuery;

/**
 * Initialize functionality
 */
const init = () => {
	$( document ).on( 'gform_post_render', function() {
		let elems = document.querySelectorAll( '.ginput_container_address .country' );

		if ( elems ) {
			$( elems ).on( 'change', countrySelected );
		}
	} );
};

/**
 * Listen for changes to the country field.
 *
 * @param {Event} e
 */
const countrySelected = ( e ) => {
	const selectElement = e.target;
	const value = selectElement.value;
	const parent = $( selectElement ).parents( '.ginput_container_address' );

	let labelEl = parent.find( '.postal_code' ).prev( 'label' );
	let stateEl = parent.find( '.administrative_area_level_1' ).closest( '.spirit-form__field-group' );
	let cityEl = parent.find( '.locality' ).closest( '.spirit-form__field-group' );
	let label;

	if ( 'United States' !== value ) {
		label = labelEl.html().replace( /ZIP Code/g, 'Postal Code' );
		stateEl.addClass( 'hide-spinner' );
		cityEl.addClass( 'spirit-col-md-12' );
	} else {
		label = labelEl.html().replace( /Postal Code/g, 'ZIP Code' );
		stateEl.removeClass( 'hide-spinner' );
		cityEl.removeClass( 'spirit-col-md-12' );
	}

	labelEl.html( label );
};

export default { init };
